export default "__VITE_ASSET__DSlDZ_HP__"